function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 21.75C6.6238 21.75 2.2499 17.3798 2.2499 12.0084C2.24528 10.5764 2.557 9.1611 3.16279 7.86355C3.76858 6.56599 4.65348 5.41825 5.75427 4.50234L6.54646 3.84609L7.86693 5.42672L7.07474 6.08297C6.20641 6.80632 5.50855 7.71253 5.03104 8.73684C4.55352 9.76116 4.30813 10.8783 4.3124 12.0084C4.3124 16.2455 7.76099 19.6927 11.9999 19.6927C16.2388 19.6927 19.6874 16.2455 19.6874 12.0084C19.6873 10.8751 19.4357 9.75601 18.9507 8.73173C18.4657 7.70746 17.7595 6.80359 16.8829 6.08531L16.086 5.42906L17.3985 3.84375L18.1954 4.5C19.3064 5.41063 20.2015 6.55646 20.8162 7.85486C21.4309 9.15327 21.7498 10.5719 21.7499 12.0084C21.7499 17.3798 17.376 21.75 11.9999 21.75Z",
  fill: "#2D3892"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9688 2.25H13.0312V12.75H10.9688V2.25Z",
  fill: "#2D3892"
});

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.fc2d1363.svg";
export { ForwardRef as ReactComponent };